{
  "appName": "Mock form minimal header",
  "entryFile": "./app-entry.jsx",
  "entryName": "mock-form-minimal-header",
  "rootUrl": "/mock-form-minimal-header",
  "productId": "d8d2c26c-6107-4917-8cf6-7002dfe1f1e5"
}
